import React, { useState } from "react"
import { Link } from "gatsby"
import { useAuth0 } from "@auth0/auth0-react"
import SearchTrigger from "./search-trigger"
import LoginButton from "./login/LoginButton"
import LogoutButton from "./login/LogoutButton"

import "../styles/header.css"

const primaryItems: [string, string][] = [
  ["ABOUT", "/about/"],
  ["INFORMATION", "/information/"],
  ["GALLERY", "/gallery/"],
  ["PLACE", "/place/"],
  ["DATA", "/data/"],
]

const secondaryItems: [string, string][] = [
  ["CONTACT", "/contact/"],
  ["FAQ", "/faq/"],
]

const Header = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isBlogOpen, setIsBlogOpen] = useState(false)
  const { isAuthenticated } = useAuth0()
  const closeMenu = () => {
    setIsOpen(false)
    setIsBlogOpen(false)
  }

  const links = (items: [string, string][]) =>
    items.map(([label, to]) => (
      <Link key={to} to={to} activeClassName="is-current" onClick={closeMenu}>
        {label}
      </Link>
    ))

  return (
    <header className="header">
      <div className="header-inner">
        <Link
          className="site-brand"
          to="/"
          aria-label="カメカフェ トップページ"
        >
          <span className="camera-mark" aria-hidden="true" />
          <span>CAMECAFE</span>
        </Link>
        <nav
          id="site-navigation"
          className={`site-navigation${isOpen ? " is-open" : ""}`}
          aria-label="メインナビゲーション"
        >
          {links(primaryItems)}
          <div className={`nav-dropdown${isBlogOpen ? " is-open" : ""}`}>
            <button
              type="button"
              className="nav-dropdown-label"
              aria-haspopup="true"
              aria-expanded={isBlogOpen}
              onClick={() => setIsBlogOpen(open => !open)}
            >
              BLOG <span aria-hidden="true">⌄</span>
            </button>
            <div className="nav-dropdown-menu">
              <Link to="/blog/event" onClick={closeMenu}>
                EVENT
              </Link>
              <Link to="/blog/submenu2" onClick={closeMenu}>
                PHOTO
              </Link>
            </div>
          </div>
          {links(secondaryItems)}
          <div className="auth-link">
            {isAuthenticated ? <LogoutButton /> : <LoginButton />}
          </div>
        </nav>
        <div className="header-actions">
          <SearchTrigger />
          <button
            className="menu-toggle"
            type="button"
            aria-expanded={isOpen}
            aria-controls="site-navigation"
            onClick={() => setIsOpen(open => !open)}
          >
            <span>{isOpen ? "CLOSE" : "MENU"}</span>
          </button>
        </div>
      </div>
    </header>
  )
}

export default Header
